/**
 * (c) 2020 KPMG LLP, a Delaware limited liability partnership
 * and the U.S. member firm of the KPMG network of independent member
 * firms affiliated with KPMG International Cooperative ("KPMG
 * International"), a Swiss entity. All rights reserved.
 */

import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IconsService } from '../@shared/services/icons.service';
import { ThemeService } from '../services/theme.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'maas-app',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [IconsService,ThemeService]
})
export class AppComponent implements OnInit {
  isIframe = window !== window.parent && !window.opener;
  theme: string = 'light-theme';

  constructor(private icons: IconsService, private themeservice: ThemeService,private overlayContainer: OverlayContainer,private cdr:ChangeDetectorRef) {

  }

  ngOnInit() {
    this.icons.init();
    this.themeservice.getCurrentTheme().subscribe((theme) => {
      this.theme = theme;
      const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
      overlayContainerClasses.remove('dark-theme', 'light-theme'); // Remove both to ensure clean slate
      overlayContainerClasses.add(theme);
      this.cdr.detectChanges();
    });
  }

}
